export default __webpack_public_path__ + "static/media/blon.8b1d47a7.png";